import { render, staticRenderFns } from "./ElectricalDamageModal.vue?vue&type=template&id=4b324a36"
import script from "./ElectricalDamageModal.vue?vue&type=script&lang=ts"
export * from "./ElectricalDamageModal.vue?vue&type=script&lang=ts"
import style0 from "./ElectricalDamageModal.vue?vue&type=style&index=0&id=4b324a36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports